import Vue from "vue";
import Vuex from 'vuex';
import mutations from './mutations';
import getters from './getters';
import createWebSocketPlugin from './ws';
import urls from '../const'

const WS = new WebSocket(urls.socketURL);
let plugin = createWebSocketPlugin(WS);

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    // заранее заиничены поля которым необходима реактивность
    order: {
      order: null,
      clientFullPrice: 0,
      clientPaid: 0,
      city: null,
      region: null,
      items: null,
      allowDeliveryDatesAndIntervals: null,
      pending: false,
      searchField: "",
    },
    // ошибки по ивентам, каждый компонент будет смотреть те ошибки которые ему интересны
    errors: {
      getOrder: {},
      setStatus: {},
      managerUsers: {},
      editUser: {},
    },
    // сообщения например об успехе, похожи на ошибки но на всякий вывел в отдельную мапу т.к. возможно их надо будет модифаить
    messages: {
      SussesSetStatus: {},
    },
    user: null,
    users: null,
    logs: null,
    wsConnectState: {
      connect: false,
      error: false,
      ws: null,
    },
  },
  mutations: mutations,
  getters: getters,
  plugins: [plugin],
});

export default store



// WEBPACK FOOTER //
// ./src/store/store.js